<!-- the context menu is deactivated because only Firefox supports it -->
<div class="hidden" type="context" id="viewerContextMenu">
  <div class="hidden" id="contextFirstPage"></div>
  <div class="hidden" id="contextLastPage"></div>
  <div class="hidden" id="contextPageRotateCw"></div>
  <div class="hidden" id="contextPageRotateCcw"></div>
</div>
